import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Trophy, Coins, Crown, Heart } from "@phosphor-icons/react";

const CATS = [
    { key: "global", label: "Wins" },
    { key: "earnings", label: "Earnings" },
    { key: "gifters", label: "Top Gifters" },
    { key: "followers", label: "Followers" },
];

export default function Leaderboard() {
    const [cat, setCat] = useState("global");
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get(`/leaderboard?category=${cat}`).then(({ data }) => setItems(data));
    }, [cat]);

    return (
        <div className="px-4 md:px-10 py-8 max-w-5xl mx-auto">
            <div className="relative rounded-sm overflow-hidden bg-wta-surface border border-wta-border mb-8">
                <img src="https://images.pexels.com/photos/6532366/pexels-photo-6532366.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
                <div className="relative p-8 md:p-12">
                    <div className="font-heading text-xs tracking-[0.4em] text-wta-accent">GLOBAL RANKINGS</div>
                    <h1 className="font-heading text-4xl md:text-7xl tracking-tight uppercase mt-2 leading-none">Leaderboard</h1>
                </div>
            </div>

            <div className="flex gap-2 overflow-x-auto no-scrollbar mb-6">
                {CATS.map((c) => (
                    <button key={c.key} onClick={() => setCat(c.key)} data-testid={`board-${c.key}`} className={`shrink-0 px-4 py-2 rounded-sm border text-sm font-heading uppercase tracking-wider ${cat === c.key ? "bg-wta-primary border-wta-primary" : "border-wta-border hover:border-white"}`}>
                        {c.label}
                    </button>
                ))}
            </div>

            <div className="bg-wta-surface border border-wta-border rounded-sm overflow-hidden">
                {items.length === 0 ? (
                    <div className="p-8 text-center text-wta-muted">No data yet</div>
                ) : items.map((u, i) => {
                    const score = cat === "earnings" ? `$${(u.earnings || 0).toFixed(2)}` :
                                  cat === "gifters" ? `${u.coins_sent || 0} coins` :
                                  cat === "followers" ? u.followers_count :
                                  u.wins;
                    const Icon = cat === "earnings" ? Coins : cat === "gifters" ? Heart : cat === "followers" ? Crown : Trophy;
                    return (
                        <Link key={u.id} to={`/profile/${u.id}`} data-testid={`board-row-${u.id}`} className={`flex items-center gap-4 px-5 py-3 hover:bg-white/5 ${i !== items.length - 1 ? "border-b border-wta-border" : ""}`}>
                            <div className={`font-heading text-3xl w-12 ${i === 0 ? "text-wta-accent" : i === 1 ? "text-white" : i === 2 ? "text-wta-primary" : "text-wta-muted"}`}>{i + 1}</div>
                            <div className="w-10 h-10 rounded-full bg-wta-surface2 border border-wta-border flex items-center justify-center font-heading">
                                {u.profile_pic ? <img src={u.profile_pic} alt="" className="w-full h-full rounded-full object-cover" /> : u.name?.[0]?.toUpperCase()}
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-sm truncate">@{u.name}</div>
                                {cat === "gifters" && u.gifter_level && (
                                    <div className="text-xs uppercase tracking-widest" style={{ color: u.gifter_level.color }}>{u.gifter_level.name} · L{u.gifter_level.level}</div>
                                )}
                            </div>
                            <div className="font-heading text-2xl flex items-center gap-2"><Icon size={18} weight="fill" /> {score}</div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
